// Sagas are what field all the async requests in redux.  They make it easier
// to deal with this data, and also make it easier to test async calls from the ui
// You can read more about them here: https://github.com/redux-saga/redux-saga

import { put, call, all, takeEvery, takeLatest } from "redux-saga/effects";
import { delay } from "redux-saga";
import { submitLoanPayment, submitAchLoanPayment, submitAppraisalCharge } from "../utils/requests";
import { errorMessages } from "../utils/content";

export function* submitPayment({ paymentDetails, paymentType }) {
  let endpoint = paymentType === 'Appraisal' ? submitAppraisalCharge : submitLoanPayment;
  try {
    yield put({
      type: "HIDE_NOTIFICATION"
    });
    yield put({
      type: "SHOW_MODAL",
      modalType: "loading",
      message: "Loading..."
    });
    let data = null;
    if(paymentType === 'ach'){
      data = yield call(submitAchLoanPayment, paymentDetails);
    } else {
      data = yield call(endpoint);
    }
    yield put({
      type: "SUBMIT_PAYMENT_COMPLETE",
      payload: data
    });
    yield put({
      type: "HIDE_MODAL",
      modalType: "loading"
    });
    // If there is an error, show the notification at the top
    if (data.PaymentError != "") {
      yield put({
        type: "SHOW_NOTIFICATION",
        notificationType: "error",
        message: data.PaymentError
      });
    } else {
      yield put({
        type: "SHOW_MODAL",
        modalType: "loading",
        complete: true,
        message: "Loading..."
      });
      yield delay(2000);
      yield put({
        type: "HIDE_MODAL",
        modalType: "loading"
      });
      // All done
      yield put({
        type: "PROCESS_COMPLETE"
      });
    }
  } catch (error) {
    yield put({
      type: "SHOW_NOTIFICATION",
      notificationType: "error",
      message: errorMessages.submittingPaymentFailed
    });
    yield put({
      type: "HIDE_MODAL",
      modalType: "loading"
    });
  }
}

// Watch for loan request and execute action to set loan state
export function* watchPaymentSubmitRequest() {
  yield takeEvery("SUBMIT_PAYMENT", submitPayment);
}



// WEBPACK FOOTER //
// ./src/sagas/submitPayment.sagas.js